import {
    DataTableCustomized,
    type DataTableColumn,
} from '@/components/ui/data-table-customized'
import { formatBandwidthUnit, formatVolumeGB } from '@/utils/function'
import React, { useMemo, useState } from 'react'
import { Typogaphy } from 'vnetwork-ui'
import { BusinessUsage as BusinessUsageType, DomainUsage } from '../../types'
import ExportDialog from './ExportDialog'

interface BusinessUsageProps {
    business: BusinessUsageType
    serviceID: number
    gte: string
    lte: string
    serviceName?: string
}

const columns: DataTableColumn<DomainUsage>[] = [
    { key: 'domain', title: 'Domain' },
    {
        key: 'volume',
        title: 'Volume',
        render: (_v, r) => formatVolumeGB(r.volume),
    },
    {
        key: 'peakBandwidth',
        title: 'Peak bandwidth',
        render: (_v, r) => formatBandwidthUnit(r.peakBandwidth),
    },
]

const BusinessUsage: React.FC<BusinessUsageProps> = ({
    business = [],
    serviceID,
    gte,
    lte,
    serviceName = 'ContentDeliveryNetwork',
}) => {
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10)
    const [search, setSearch] = useState('')

    const rows = useMemo(() => {
        const q = search.trim().toLowerCase()
        const list = q
            ? (business || []).filter((d) =>
                  d.domain?.toLowerCase().includes(q)
              )
            : business || []
        return [...list].sort((a, b) => (b?.volume || 0) - (a?.volume || 0))
    }, [business, search])

    const paged = rows.slice((page - 1) * pageSize, page * pageSize)

    return (
        <div className="bg-white rounded-[8px] p-4">
            <div className="mb-2 flex items-center justify-between">
                <Typogaphy size="medium" className="text-primary font-semibold">
                    Business Usage
                </Typogaphy>
                <ExportDialog
                    serviceID={serviceID}
                    gte={gte}
                    lte={lte}
                    serviceName={serviceName}
                    disabled={!rows.length}
                />
            </div>
            <DataTableCustomized<DomainUsage>
                columns={columns}
                rows={paged}
                rowKey={(row) => row.domain}
                size="small"
                bordered
                emptyMessage="No data"
                toolbar={{
                    search: {
                        value: search,
                        onChange: (value) => {
                            setSearch(value)
                            setPage(1)
                        },
                        placeholder: 'Search domain...',
                    },
                }}
                pagination={{
                    page,
                    pageSize,
                    total: rows.length,
                    pageSizeOptions: [10, 20, 50],
                    onPageChange: setPage,
                    onPageSizeChange: (size) => {
                        setPageSize(size)
                        setPage(1)
                    },
                }}
            />
        </div>
    )
}

export default BusinessUsage
